This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div>
    <div class="basicBlock select-none withHeaderBeam">
      <p class="header upper">{{ $t("levelMaker.blocks") }}</p>
      <div class="grid grid-cols-2 blocks-2">
        <div
          :class="
            selected == 'start'
              ? 'blockEntry selected'
              : 'blockEntry selectable'
          "
          @click="changeBlock({ name: 'Start', id: 'start' })"
        >
          Start
        </div>
        <div
          :class="
            selected == 'stop' ? 'blockEntry selected' : 'blockEntry selectable'
          "
          @click="changeBlock({ name: 'Stop', id: 'stop' })"
        >
          Einde
        </div>
      </div>

      <div class="grid grid-cols-4 blocks-4">
        <div
          class="blockEntry"
          v-for="image in images"
          :class="[selected == image.id ? 'selected' : 'selectable']"
          :key="image.id"
          @click="changeBlock(image)"
        >
          <img
            class="svgImage"
            :src="require(`@/assets/images/levelMaker/${image.name}.svg`)"
            alt="Grid tile option"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  data() {
    return {
      selected: "",
    };
  },
  methods: {
    /**
     * Change the current block shape
     * @param input Name and id of the new shape
     */
    changeBlock(input: { name: string; id: string }) {
      this.selected = input.id;
      this.$emit("changeBlock", input.id);
    },
  },
  props: {
    images: Array,
    currentBlock: String,
  },
  mounted() {
    this.selected = this.currentBlock;
  },
})
export default class LevelEditorBlocks extends Vue {}
</script>
